// Module
var code = `<h2 class="section-header">Please confirm the following:</h2>
<form name="\$ctrl.form">
  <table class="table">
    <tbody>
    <tr>
      <td>Content:</td>
      <td>
        <file-upload ng-model="\$ctrl.contentFile"
                     required
                     validate-uploaded
                     max-files="1"
                     validate="{pattern: '.csv,*.txt', size: { max: '5MB'}}"
                     show-remarks="false"
                     enable-webcam="false">
        </file-upload>
      </td>
    </tr>
    </tbody>
  </table>

  <div class="summary-actions">
    <button
      type="button"
      class="btn btn-info"
      ng-click="\$ctrl.downloadSampleFile()">
      Download sample file
    </button>
    <button
      type="submit"
      class="btn btn-success"
      ng-disabled="\$ctrl.form.\$invalid"
      ng-click="\$ctrl.execute()">
      Execute
    </button>
  </div>
</form>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/support/misc/activate-accounts/activate-accounts.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;